import { render, staticRenderFns } from "./sort-selection.vue?vue&type=template&id=52667d82&scoped=true&"
import script from "./sort-selection.vue?vue&type=script&lang=js&"
export * from "./sort-selection.vue?vue&type=script&lang=js&"
import style0 from "./sort-selection.vue?vue&type=style&index=0&id=52667d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52667d82",
  null
  
)

export default component.exports